<template>
    <div class="z-100 fixed flex flex-col justify-center items-center top-0 left-0 w-screen h-screen" id="content-popup-modal">
        <div class="absolute w-screen h-screen top-0 left-0 -z-50 bg-gray-800 bg-opacity-50" @click.prevent="close"></div>
        <div class="fixed bg-white px-8 py-6 flex flex-col gap-4 overflow-y-scroll w-600">
            <button class="absolute top-4 right-4 w-8 h-8 rounded-full bg-gray-100 flex justify-center items-center" @click.prevent="close" style="border: 0; cursor: pointer; background: none; opacity: 0.5;">
                <svg class="w-4 h-4 text-gray-600" width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.3398 16.7227C18.6133 16.9961 18.75 17.3281 18.75 17.7188C18.75 18.1094 18.6133 18.4414 18.3398 18.7148C18.0664 18.9883 17.7344 19.125 17.3438 19.125C16.9531 19.125 16.6211 18.9883 16.3477 18.7148L9.375 11.7422L2.40234 18.7148C2.12891 18.9883 1.79688 19.125 1.40625 19.125C1.01562 19.125 0.683594 18.9883 0.410156 18.7148C0.136719 18.4414 0 18.1094 0 17.7188C0 17.3281 0.136719 16.9961 0.410156 16.7227L7.38281 9.75L0.410156 2.77734C0.136719 2.50391 0 2.17188 0 1.78125C0 1.39062 0.136719 1.05859 0.410156 0.785156C0.683594 0.511719 1.01562 0.375 1.40625 0.375C1.79688 0.375 2.12891 0.511719 2.40234 0.785156L9.375 7.75781L16.3477 0.785156C16.6211 0.511719 16.9531 0.375 17.3438 0.375C17.7344 0.375 18.0664 0.511719 18.3398 0.785156C18.6133 1.05859 18.75 1.39062 18.75 1.78125C18.75 2.17188 18.6133 2.50391 18.3398 2.77734L11.3672 9.75L18.3398 16.7227Z" fill="currentColor"/>
                </svg>
            </button>
            <div class="flex flex-col flex-1 gap-4">
                <slot/>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Modal",
        props: {
            contentPopupId: {
                required: false,
            }
        },
        data() {
            return {}
        },
        methods: {
            close() {
                $("#content-popup-modal").hide();
                let cookieName = 'popup_seen_' + this.contentPopupId;
                this.setCookie(cookieName, 1);
            },
            setCookie(name, value) {
                var expdate = new Date();
                expdate.setTime(expdate.getTime() + 1000 * 60 * 60 * 24 * 30);
                document.cookie = name + "=" + value + "; expires=" + expdate.toGMTString() + "; path=/";
            }
        },
    }
</script>

<style>
    .w-screen {
        width: 100vw;
    }
    .h-screen {
        height: 100vh;
    }
    .w-600{
        width: 600px;
    }
    .justify-center{
        justify-content: center;
    }
    .items-center{
        align-items: center;
    }
    .flex-col{
        flex-direction: column;
    }
    .flex{
        display: flex;
    }
    .z-100{
        z-index: 200;
    }
    .top-0{
        top: 0;
    }
    .left-0{
        left: 0;
    }
    .fixed{
        position: fixed;
    }
    .bg-opacity-50 {
        --tw-bg-opacity: 0.5;
    }
    .bg-gray-800 {
        --tw-bg-opacity: 0.5;
        background-color: rgb(31 41 55/var(--tw-bg-opacity));
    }
    .-z-50 {
        z-index: -50;
    }
    .absolute {
        position: absolute;
    }
    .bg-white{
        background-color: white;
    }
    .right-4{
        right: 1rem;
    }
    .top-4{
        top: 1rem;
    }
    .bg-gray-100:hover{
        --tw-bg-opacity: 1;
        background-color: rgb(243 244 246/var(--tw-bg-opacity));
    }
</style>
